import { render, staticRenderFns } from "./AccountslTable.vue?vue&type=template&id=4d76c704&scoped=true&"
import script from "./AccountslTable.vue?vue&type=script&lang=js&"
export * from "./AccountslTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountslTable.vue?vue&type=style&index=0&id=4d76c704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d76c704",
  null
  
)

export default component.exports